import axios from "axios";

const url = "https://vapi.vnappmob.com/api/province/";

class AddressApi {
  getAllCity = () => {
    return axios.get(url);
  };

  getDistrictsByIdCity = (idCity) => {
    return axios.get(`${url}/district/${idCity}`);
  };

  getWardsByIdDistrict = (idDistrict) => {
    return axios.get(`${url}/ward/${idDistrict}`);
  };
}
const addressApi = new AddressApi();
export default addressApi;
